import useGlobalSettings from "src/core/shared/hooks/useGlobalSettings";

const useMinimumLeadTime = () => {
  const [ { isLoading, globalSettings } ] = useGlobalSettings();
  let minimumLeadTime = null;

  if (globalSettings && globalSettings.minimumLeadTime) {
    minimumLeadTime = globalSettings.minimumLeadTime;
  }

  return {
    isLoading,
    minimumLeadTime
  };
};

export default useMinimumLeadTime;
